import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Grid } from '@mui/material';
import Pregunta1 from './Pregunta1';
import Pregunta2 from './Pregunta2';
import Pregunta3 from './Pregunta3';
import Pregunta4 from './Pregunta4';
import Pregunta5 from './Pregunta5';
import Pregunta6 from './Pregunta6';
import Pregunta7 from './Pregunta7';
import Pregunta8 from './Pregunta8';
import Pregunta9 from './Pregunta9';
import Pregunta10 from './Pregunta10';
import Pregunta11 from './Pregunta11';
import Pregunta12 from './Pregunta12';
import Pregunta13 from './Pregunta13';
import Pregunta14 from './Pregunta14';
import Pregunta15 from './Pregunta15';
import { setData, top, updateData, getCollectionsComplete } from '../../assets/js/functions';
import ValidateSession from '../../components/ValidateSession';
import logo from '../../assets/images/header/Logo.svg';
import './styles.scss';

export default function Preguntas() {
  const [pregunta, setPregunta] = useState(1);
  const [respuestas, setRespuestas] = useState({});
  const [puntos, setPuntos] = useState(0);
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    localStorage.removeItem('puntos');
    localStorage.removeItem('respuestas');
  }, []);

  const setRespuesta = async (preg, resp) => {
    let json = { ...respuestas, [preg]: resp };
    setRespuestas(json);
    // console.log(puntosganados);
    // console.log(localStorage.getItem(puntos));
  };

  const sumarPuntos = (cantidad) => {
    let puntuacion = parseInt(localStorage.getItem('puntos')) || 0;
    let suma = puntuacion + cantidad;
    localStorage.setItem('puntos', suma);
    setPuntos(suma);
  };

  const cambiarPregunta = (num) => {
    setPregunta(num);
    top();
  };

  const guardar = () => {
    let json = JSON.parse(sessionStorage.getItem('respuestas'));
    let puntuacionFinal = localStorage.getItem('puntos');
    let usuario = sessionStorage.getItem('mx');
    if (puntuacionFinal > 8) {
      setData('preguntas', usuario, { ...json, puntos: puntuacionFinal })
        .then(() => {
          console.log('guardado');
          navigate('/aprobo');
        })
        .catch((e) => {
          console.log('error: ' + e);
        });
    } else {
      navigate('/intentalo-de-nuevo');
    }

    console.log(respuestas);
    console.log(puntos);
  };

  return (
    <>
      <ValidateSession id={params.id}>
        <div id='preguntas'>
          <div className='header'>
            <img src={logo} alt='logo' />
          </div>
          <Container maxWidth='lg'>
            <Grid container justifyContent='center' alignItems='center' spacing={4}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div className='instrucciones'>{`${pregunta < 9 ? 'Realiza cada ejercicio a partir de su planteamiento.' : 'Lee con atención cada caso y selecciona la respuesta que consideres adecuada.'}`}</div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div className='contador'>
                  <h2 className='azul'>{`pregunta ${pregunta} / 15`}</h2>
                </div>
              </Grid>
            </Grid>
          </Container>
          {pregunta === 1 && <Pregunta1 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 2 && <Pregunta2 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 3 && <Pregunta3 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 4 && <Pregunta4 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 5 && <Pregunta5 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 6 && <Pregunta6 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 7 && <Pregunta7 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 8 && <Pregunta8 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 9 && <Pregunta9 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 10 && <Pregunta10 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 11 && <Pregunta11 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 12 && <Pregunta12 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 13 && <Pregunta13 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 14 && <Pregunta14 setRespuesta={setRespuesta} sumarPuntos={sumarPuntos} cambiarPregunta={cambiarPregunta} />}
          {pregunta === 15 && <Pregunta15 sumarPuntos={sumarPuntos} puntos={puntos} respuestas={respuestas} guardar={guardar} />}
          {/*
           */}
          {/* <Container maxWidth='lg'>
						<Grid container justifyContent='center' alignItems='center' spacing={4}>
							<Grid item xs={12} sm={12} md={12} lg={12}>
								<div className='siguiente' onClick={() => guardar()}>
									Guardar
								</div>
							</Grid>
						</Grid>
					</Container> */}
        </div>
      </ValidateSession>
    </>
  );
}
